import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { Button } from "../../Components/CustomComponents/index.js";
import Table from "../../Components/Table/Table.js";
import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { BiSupport } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";
import MainCard from "../../Components/Cards/MainCard.js";
import ToolTip from "../../Components/CustomComponents/ToolTip.js";
import DeleteModal from "../../Components/Modals/DeleteModal.js";
import EditPageModal from "../../Components/Modals/EditPageModal.js";
import { useDeletePageMutation } from "../../Data/services/pageApi.js";
import Toast, { SuccessToast } from "../../Hooks/useToast.js";
import Header from "../UserManagement/Components/Header.js";
import { FiEye } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants.js";
import CustomerSupportSkeleton from "../../Components/Skeleton/CustomerSupportSkeleton.js";
// import { useDeleteReportTypeMutation } from "../../Data/services/reportTypeApi.js";

const CustomerSupportScreen = ({ setPage }) => {
  const { control, watch } = useForm({
    defaultValues: {
      status: "",
    },
  });

  const status = watch("status");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [rowData, setRowData] = useState([]);
  const [editedData, setEditedData] = useState("");

  const [loading, setLoading] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const filterData = [
    {
      value: "all",
      label: "All Content",
    },
    {
      value: 0,
      label: "Blogs",
    },
    {
      value: 1,
      label: "Posts",
    },
    {
      value: 2,
      label: "Announcements",
    },
  ];

  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const dummyData = [
    {
      id: 1,
      title: "Payment Issue",
      assignedTo: "John Doe",
      timeAgo: "2 hours ago",
      status: "urgent",
      priority: "high",
    },
    {
      id: 2,
      title: "Account Access",
      assignedTo: "Jane Smith",
      timeAgo: "4 hours ago",
      status: "open",
      priority: "medium",
    },
    {
      id: 3,
      title: "Feature Request",
      assignedTo: "Bob Wilson",
      timeAgo: "1 day ago",
      status: "pending",
      priority: "low",
    },
  ];

  const handleSearchChange = (event) => {
    const query = event.target.value;
    // console.log("Search query:", query); // You can use this to trigger a search function
    setSearchQuery(query);
  };

  const handleDeleteModalOpen = () => {
    setDeleteModal(true);
  };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  const handleEditModalOpen = () => {
    setEditModal(true);
  };

  const handleEditModalClose = () => {
    setEditModal(false);
    setEditedData("");
  };

  const handleAddUser = () => {
    setEditModal(true);
  };

  const [deletePage, { isLoading: isDeleting }] = useDeletePageMutation();

  const deleteData = async (slug) => {
    try {
      const { data } = await deletePage(slug);
      if (data.code === 200) {
        // await refetch();
        handleDeleteModalClose();
        SuccessToast(data.message);
      }
    } catch (error) {
      // console.log(error);
      Toast(error.message, "error");
    }
  };

  function indication() {
    // return something here
    // return 'Table is empty';
    return indicationMessage;
  }

  const columns = [
    {
      dataField: "title",
      text: "Title",
      headerStyle: { width: "250px" },
      style: { whiteSpace: "normal", wordBreak: "break-word" },
    },
    {
      dataField: "assignedTo",
      text: "Assigned To",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "180px" },
    },
    {
      dataField: "timeAgo",
      text: "Time",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
    },
    {
      dataField: "status",
      text: "Status",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent) => {
        const badgeClass =
          cellContent === "urgent"
            ? "bg-danger-subtle text-danger"
            : cellContent === "open"
            ? "bg-primary-subtle text-primary"
            : "bg-secondary-subtle text-secondary";

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },
    {
      dataField: "priority",
      text: "Priority",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "150px" },
      formatter: (cellContent) => {
        const badgeClass =
          cellContent === "high"
            ? "bg-danger text-white"
            : cellContent === "medium"
            ? "bg-warning text-dark"
            : "bg-light text-dark";

        return (
          <span className={`badge rounded-pill ${badgeClass}`}>
            {cellContent}
          </span>
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: { width: "120px" },
      formatter: (cellContent, row) => (
        <ToolTip placement={"top"} content={"View"}>
          <button
            className="btn btn-sm btn-primary rounded-pill"
            onClick={() => {
              navigate(WEB_ROUTES.SINGLE_CHAT, { state: { data: row } });
            }}
          >
            <FiEye />
          </button>
        </ToolTip>
      ),
    },
  ];

  return (
    <div className={styles.MainContainer}>
      {deleteModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <DeleteModal
            handleDeleteModalClose={handleDeleteModalClose}
            data={editedData}
            isDeleting={isDeleting}
            onDelete={deleteData}
          />
        </Suspense>
      ) : (
        ""
      )}

      {editModal ? (
        <Suspense fallback={<Spinner animation="grow" size="sm" />}>
          <EditPageModal
            handleEditModalClose={handleEditModalClose}
            editData={editedData}
            // refetch={refetch}
          />
        </Suspense>
      ) : (
        ""
      )}

      <div className={styles.headerContainer}>
        <div>
          <Header
            title={"Customer Support"}
            subTitle={
              "Manage support tickets, moderation queue, and compliance reports."
            }
          />
        </div>
      </div>

      {dummyFetch?.isLoading ? (
        <CustomerSupportSkeleton />
      ) : (
        <>
          <div style={{ width: "200px" }}>
            <Button
              classes={`${styles.cardBtn} px-3 mt-3 bg-white primary-text shadow-sm`}
              text={"Support Hub"}
              // onClick={handleAddUser}
            ></Button>
          </div>

          <br />

          <MainCard>
            <span className="d-flex gap-2">
              <BiSupport size={"28px"} />
              <h5>Support Tickets</h5>
            </span>
            <div
              // className={`${styles.mainTable} ${
              //   dataFetched && isFetching ? "blur-table" : ""
              // }`}
              className={styles.mainTable}
            >
              {/* {!dataFetched || !isSuccess ? (
          <CustomLoader />
        ) : ( */}
              <div className={styles.mainTable}>
                {
                  <Table
                    data={dummyData || []}
                    columns={columns}
                    indication={indication}
                    totalRecords={totalRecords} // todo
                    totalPages={totalPages} // todo
                    pageSize={pageSize} // todo
                    currentPage={currentPage} // todo
                    setCurrentPage={setCurrentPage} // todo
                    setPageSize={setPageSize} // todo
                    // refetch={refetch} // todo
                    refetch={() => {}} // todo
                  />
                }
              </div>
              {/* )} */}
            </div>
          </MainCard>
        </>
      )}
    </div>
  );
};

export default CustomerSupportScreen;
